module.exports = __webpack_public_path__ + "static/media/checkin-printer-a.0998edc3.png";